import { candidate } from "./axiosConfig";

const getJobSlug = (job) => job.url?.split("/").filter(x => !!x).pop();

export const CandidateAPI = {
  setBookmarkFalg: async function(response) {
    var jobSlugs = response.data?.jobs?.map(getJobSlug).filter(slug => !!slug);

      if(jobSlugs && jobSlugs.length) {
          var formData = new FormData();
          
          jobSlugs.forEach(function(jobSlug) {
            formData.append("jobSlugs[]", jobSlug)
          });

          const bookmarkedResponse =  await candidate.request({
            url: "/candidate/are-bookmarked/",
            method: "POST",
            data: formData
          });
          
          if(bookmarkedResponse && bookmarkedResponse.data?.succeeded && bookmarkedResponse.data?.data) {
            response.data?.jobs?.forEach(job => {
              var jobSlug = getJobSlug(job);
              job.bookmarked = bookmarkedResponse.data.data[jobSlug] === true;
            });
          }
      }
  },
  bookmark: async function (job) {
    const response = await candidate.request({
      url: "/candidate/bookmark/" + getJobSlug(job) + "/",
      method: "POST"
    });
    return response;
  },
  unbookmark: async function (job) {
    const response = await candidate.request({
      url: "/candidate/unbookmark/" +  getJobSlug(job) + "/",
      method: "POST"
    });
    return response;
  },
};

export default CandidateAPI;
